import { PropsWithChildren } from 'react'
import { Box, Container, SxProps, Theme } from '@mui/material'

import { formWrapStyles } from 'common/styles'
import { Sidebar } from 'components/Sidebar'
import StyledWrap from 'components/StyledWrap'

import SubHeader from './SubHeader'

const styles: Record<string, SxProps<Theme>> = {
  mainContainer: {
    display: 'block',
    flex: '1 1 auto',
    width: '100%',
    paddingRight: {
      xs: '20px',
      md: '24px',
    },
    paddingLeft: {
      xs: '20px',
      md: '24px',
    },
  },
}

const StepContainer = ({ children }: PropsWithChildren): JSX.Element => {
  return (
    <>
      <Sidebar />
      <StyledWrap wrapCss="width: 100%;" elementName="FormContainer">
        <Box className="main-content" sx={styles.mainContainer}>
          <SubHeader />
          <Container disableGutters sx={formWrapStyles.container}>
            <Box className="main-content-inner" sx={formWrapStyles.box}>
              {children}
            </Box>
          </Container>
        </Box>
      </StyledWrap>
    </>
  )
}

export default StepContainer
